module.exports = __webpack_public_path__ + "static/img/jd.66ac01cd.jpg";